export const environment = {
  production: false,
  apiUrl: 'https://qa-api.leasingsentral.com', // URL base para el backend en QA
  apiUrlConsult:
    'https://leasing-int-qa.apps.ambientesbc.com/leasingsentral/ls',
  modulesConfigFileUrl: '/assets/modules-config-qa.json',
  BDS_ICONS_URL: 'https://library-sdb.apps.bancolombia.com/bds/8.0.0',
  msal: {
    clientId: '5f3990a3-714b-4c74-a9bd-db77cd620742',
    authority:
      'https://login.microsoftonline.com/428f4e2e-13bf-4884-b364-02ef9af41a1d',
    redirectUri: 'https://leasing-sentral-qa.apps.ambientesbc.com/home',
    postLogoutRedirectUri: 'https://leasing-sentral-qa.apps.ambientesbc.com',
    scopes: ['openid', 'profile', 'api://5f3990a3-714b-4c74-a9bd-db77cd620742/.default'],
  },
  mfAuthUrl: 'https://leasing-sentral-qa.apps.ambientesbc.com/mf-auth_Front/remoteEntry.js',
  mfHomeUrl: 'https://leasing-sentral-qa.apps.ambientesbc.com/mf-home_Front/remoteEntry.js',
  mfCuentaCobroUrl: 'https://leasing-sentral-qa.apps.ambientesbc.com/mf-cuenta-cobro_Front/remoteEntry.js',
  mfGestorParametrosUrl: 'https://leasing-sentral-qa.apps.ambientesbc.com/mf-parametros_Front/remoteEntry.js',
  mfContactabilidadUrl: 'https://leasing-sentral-qa.apps.ambientesbc.com/mf-contactabilidad_Front/remoteEntry.js',
  mfHerramientaActivoUrl: '',
  manualToken: {
    enabled: false,
    storageKey: 'mf-host-manual-token',
    inlineToken: '',
  },
  menuGroupIds: {
    home: '',
    cuentaCobro: '9c3d1bca-49e3-4518-bee0-853a0ed3ab4e',
    gestorParametros: '9c3d1bca-49e3-4518-bee0-853a0ed3ab4e',
    herramientaActivo: '7e320690-26b3-4f43-aab6-9ef148ba58a3',
  },
};
